module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/ltr.1dd6a230.svg";